import folderStore, { Folder } from 'owa-folders';
import { select } from 'satcheljs/lib/legacy';
import { FolderTableState, isUnderDistinguishedFolder } from 'owa-folders';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';

export default select<FolderTableState>({
    folderTable: () => folderStore.folderTable,
})(function isFolderUnderDeletedItemsFolder(
    folder: Folder,
    distinguishedFolderId: DistinguishedFolderIdName,
    state?: FolderTableState
): boolean {
    return isUnderDistinguishedFolder(folder, distinguishedFolderId, state);
});
